import { render, staticRenderFns } from "./InvestmentInput.vue?vue&type=template&id=54e2f7be"
import script from "./InvestmentInput.vue?vue&type=script&lang=js"
export * from "./InvestmentInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports